<template>
<Box @close="close({})" v-if="pedido_items">
    <template #top>
        Pedido de Compra: {{ pedido_items.pei_id }}
    </template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <InputText label="Proyecto" v-model="pedido_items.pry_nombre" disabled></InputText>
                    <InputText label="Estado" v-model="pedido_items.est_nombre" disabled></InputText>
                </div>
                <div class="nj-grid">
                    <InputText label="Fecha registro" v-model="pedido_items.pei_fecha_registro" disabled></InputText>
                    <InputSelect id="dp-1" label="Almacenes" v-model="pedido_items.alm_id" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes"
                        :labelFunction="labelAlmacen" @selectItem="buscarEmpleados($event)" disabled>
                        <template #default="data">
                            {{ labelAlmacen(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect id="dp-2" label="Solicitante" v-model="pedido_items.usu_solicitante" :source="empleadosLogistica" itemKey="usu_id" itemValue="usu_id"
                        :filterFunction="filterSolicitante" :labelFunction="labelSolicitante" disabled>
                        <template #default="data">
                            {{ labelSolicitante(data.item) }}
                        </template>
                    </InputSelect>
                    <InputSelect id="dp-3" label="Logistica" v-model="pedido_items.usu_logistica" :source="empleadosSolicitante" itemKey="usu_id" itemValue="usu_id" :filterFunction="filterLogistica"
                        :labelFunction="labelLogistica" disabled>
                        <template #default="data">
                            {{ labelLogistica(data.item) }}
                        </template>
                    </InputSelect>
                </div>
                <div class="nj-grid">
                    <InputTextarea label="Notas" v-model="pedido_items.pei_notas" disabled></InputTextarea>
                </div>
                <br>
                <b-table :data="pedido_items.lista_pedido_items_detalle" style="width: 100%;">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info" style="width: 60px;">{{ props.row.prv_id }}</b-table-column>
                        <b-table-column label="Producto" header-class="is-info">{{ props.row.pid_producto }}</b-table-column>
                        <b-table-column label="C. Solicitada" header-class="is-info" style="width: 100px;">
                            <input type="text" class="nj-text right" v-model="props.row.pid_cantidad_solicitada" disabled />
                        </b-table-column>
                        <b-table-column label="C. Aprobada" header-class="is-info" style="width: 100px;">
                            <input type="text" class="nj-text right" v-model="props.row.pid_cantidad_aprobada" disabled />
                        </b-table-column>
                        <b-table-column label="C. Comprada" header-class="is-info" style="width: 100px;">
                            <input type="text" class="nj-text right" v-model="props.row.oci_cantidad" disabled />
                        </b-table-column>
                        <b-table-column label="OC" header-class="is-info" style="width: 200px;">{{ props.row.ord_code }}</b-table-column>
                        <b-table-column label="Proveedor" header-class="is-info">{{ props.row.pve_razon_social }}</b-table-column>
                        <!-- <b-table-column label="Transferencia" header-class="is-info" style="width: 100px;"></b-table-column> -->
                    </template>
                </b-table>
            </div>
        </div>
    </template>
</Box>
</template>
<script>
import { EmpleadoService, PedidoItemsService, ProductoService, ResponseStatus } from "../../rest"
import { Data } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, InputSearch, InputSelect, InputText, InputTextarea } from "../components"
export default {
    name: "VerPedidoItems",
    props: {
        pei_id: null
    },
    components: {
        Box,
        InputText,
        InputTextarea,
        InputSelect,
        Button,
        InputSearch,
    },
    data() {
        return {
            pedido_items: {},
            productos: [],
            almacenes: [],
            empleadosLogistica: [],
            empleadosSolicitante: []
        }
    },
    methods: {
        close({
            componente = "ver",
            activar = false,
            renderizar = false
        }) {
            this.$emit("close", {
                componente,
                activar,
                renderizar,
            })
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => item.alm_nombre.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        buscarEmpleados(almacen) {
            EmpleadoService
                .buscar({
                    empleado: {
                        pry_id: almacen.pry_id,
                    }
                })
                .then(response => {
                    this.empleadosLogistica = response.data
                    const request = {
                        empleado: {
                            pry_id: almacen.pry_id,
                        }
                    }
                    EmpleadoService
                        .buscar(request)
                        .then(response => {
                            this.empleadosSolicitante = response.data
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        filterLogistica(items, param) {
            if (param != null) {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelLogistica(item) {
            return item.emp_nombre_completo
        },
        filterSolicitante(items, param) {
            if (param != null) {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelSolicitante(item) {
            return item.emp_nombre_completo
        },
        buscarProductos(prv_nombre) {
            ProductoService
                .buscarRapido({
                    producto: {
                        prv_nombre
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.productos = response.data
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        agregarProducto(producto) {
            if (producto != null) {
                this.pedido_items.lista_pedido_items_detalle.push({
                    pid_id: null,
                    prv_id: producto.prv_id,
                    pid_producto: producto.prv_nombre
                })
            }
        },
        remover(producto) {
            this.pedido_items.lista_pedido_items_detalle = this.pedido_items.lista_pedido_items_detalle
                .filter(item => item.prv_id != producto.prv_id)
        },
    },
    mounted() {
        PedidoItemsService
            .obtener({
                pedido_items: {
                    pei_id: this.pei_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.pedido_items = response.data
                    this.almacenes = Data.getAlmacenes()
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>